<template>
  <ElementLayout>
    <!-- @vue-ignore -->
    <template #element>
      <!-- @vue-ignore -->
      <date-picker
        density="compact"
        v-model="value"
        label=""
        hide-input-icon
      ></date-picker>
    </template>
  </ElementLayout>
</template>

<script lang="ts">
import { defineElement } from '@vueform/vueform'
import DatePicker from '@/components/vuetify-extensions/DatePicker.vue'

interface Element {
  value: Date
}

interface Context {
  element: Element
}

export default defineElement({
  name: 'CustomDatepickerElement',
  components: { DatePicker },
  setup(props: Object, { element }: Context) {
    const { value } = element
    return { value }
  }
})
</script>
